export default {
  data: () => ({
    observersForValidate: [],
  }),
  props: {
    validate: {
      type: [Boolean, Number],
      default: false,
    },
  },
  methods: {
    async validateObserver({ observer, name }) {
      if (observer != undefined) {
        return { name, isValid: await observer.validate() };
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async validateSection() {
      let validations = [];

      this.observersForValidate.forEach(async (observer) => {
        validations.push(await this.validateObserver(observer));
      });
      await this.sleep(25);
      this.$store.commit('setComponentValidated', validations);
    },
  },
  watch: {
    async validate() {
      await this.validateSection();
    },
  },
};
